import { useState, useEffect } from 'react';
import type { Section, Option, DataJson, DefaultOption, Mode, LocalizedString, ProjectDescriptionConfig } from '../types';
import projectData from '../data/data_talli.json';

export const useData = () => {
  const [companyName, setCompanyName] = useState<string>('');
  const [sections, setSections] = useState<Section[]>([]);
  const [options, setOptions] = useState<Option[]>([]);
  const [defaultOptions, setDefaultOptions] = useState<DefaultOption[]>([]);
  const [modes, setModes] = useState<Mode[]>([]);
  const [modesLabel, setModesLabel] = useState<LocalizedString | undefined>(undefined);
  const [projectDescriptionConfig, setProjectDescriptionConfig] = useState<ProjectDescriptionConfig | undefined>(undefined);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    try {
      // Simulate async loading (in real app, this might be an API call)
      const loadData = () => {
        const data = projectData as DataJson;
        // Map from snake_case (JSON) to camelCase (application)
        setCompanyName(data.company_name || '');
        setSections(data.sections);
        setOptions(data.options);
        setOptions(data.options);
        setDefaultOptions(data.default_options || []);
        setModes(data.modes || []);
        setModesLabel(data.modes_label);
        setProjectDescriptionConfig(data.project_description);
        setIsLoading(false);
      };

      // Add a small delay to show loading state (optional)
      setTimeout(loadData, 100);
    } catch (err) {
      setError('Failed to load project data');
      setIsLoading(false);
      console.error('Error loading data:', err);
    }
  }, []);

  return {
    companyName,
    sections,
    options,
    defaultOptions,
    modes,
    modesLabel,
    projectDescriptionConfig,
    isLoading,
    error
  };
};